import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'my-degree-detail-progress-bar',
    templateUrl: './my-degree-detail-progress-bar.component.html',
    styleUrls: ['./my-degree-detail-progress-bar.component.scss'],
    standalone: false
})
export class MyDegreeDetailProgressBarComponent implements OnInit {
    @Input() complete: number;
    @Input() inProgress: number;
    @Input() remaining: number;

    constructor() {}

    public ngOnInit(): void { }

}
